import * as yup from 'yup'
import { createDataSchema } from '../schemaUtils'

export const anchorDataSchema = createDataSchema(
	'Anchor',
	yup.object({
		name: yup.string(),
		compId: yup.string(),
	})
)
